import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";
import { useSelections } from "../../context/Selections";
import KpiCard from "../../components/KpiCard/KpiCard";

const OBJECT_IDS = {
  KPI_TITLE_01: "wXj",
  KPI_TITLE_02: "dxckBKc",
  KPI_TITLE_03: "CjAsfPv",
  KPI_TITLE_04: "vmyTvh",

  CARD_NAME_01: "fKJSKA",
  CARD_NAME_02: "MjHTcEM",
  CARD_NAME_03: "pHgvjf",

  CARD_DATE_01: "ReAjsp",
  CARD_DATE_02: "WggdaSZ",
  CARD_DATE_03: "BQfadWA",

  KPI_REALIZADO: "jYGhDw",
  KPI_META: "jANpxJ",
  KPI_ATING: "JAYTJU",

  REALI_01: "tTLEG",
  REALI_02: "TurPRCm",
  REALI_03: "JUZeVJN",
};

function SellOutTotalDesktop({ app, config }) {
  const { selections } = useSelections();
  const [nameKpi01, setNameKpi01] = useState();
  const [nameKpi02, setNameKpi02] = useState("P07");
  const [nameKpi03, setNameKpi03] = useState("P08");
  const [nameKpi04, setNameKpi04] = useState("P09");

  const [month01, setMonth01] = useState("Janeiro/2025");
  const [month02, setMonth02] = useState("Fevereiro/2025");
  const [month03, setMonth03] = useState("Março/2025");

  const [valueRealizado, setValueRealizado] = useState();
  const [valueRealizado02, setValueRealizado02] = useState();
  const [valueRealizado03, setValueRealizado03] = useState();

  const getTitles = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          position === 1 && setNameKpi01(value);
          position === 2 && setNameKpi02(value);
          position === 3 && setNameKpi03(value);
          position === 4 && setNameKpi04(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  const getDateObject = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          let value = res?.model?.layout?.style?.label;

          position === 1 && setMonth01(value);
          position === 2 && setMonth02(value);
          position === 3 && setMonth03(value);
        } catch (error) {
          console.error("Erro ao buscar valores do objeto:", error);
        }
      }
    },
    [app]
  );

  const getValueRealizado = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          let value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          position === 1 && setValueRealizado(value);
          position === 2 && setValueRealizado02(value);
          position === 3 && setValueRealizado03(value);
        } catch (error) {
          console.error("Erro ao buscar valores do objeto:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getTitles(OBJECT_IDS.KPI_TITLE_01, 1);
      getTitles(OBJECT_IDS.KPI_TITLE_02, 2);
      getTitles(OBJECT_IDS.KPI_TITLE_03, 3);
      getTitles(OBJECT_IDS.KPI_TITLE_04, 4);
    }
  }, [app, getTitles, selections]);

  useEffect(() => {
    if (app) {
      getValueRealizado(OBJECT_IDS.REALI_01, 1);
      getValueRealizado(OBJECT_IDS.REALI_02, 2);
      getValueRealizado(OBJECT_IDS.REALI_03, 3);
    }
  }, [app, getValueRealizado, selections]);

  useEffect(() => {
    if (app) {
      getDateObject(OBJECT_IDS.CARD_DATE_01, 1);
      getDateObject(OBJECT_IDS.CARD_DATE_02, 2);
      getDateObject(OBJECT_IDS.CARD_DATE_03, 3);
    }
  }, [app, getDateObject, selections]);

  return (
    <div className="app sell-out-total">
      <div className="appContent">
        <LayoutWrapper>
          <Grid>
            <Card className="container-card-only-title">
              <h1 className="title">Sell Out Total</h1>
            </Card>
          </Grid>

          <Grid
            container
            className="container-sell-out-total"
            style={{ margin: "1.9px 0 0 0" }}
          >
            <Grid container className="container-cards-kpi">
              <Card app={app} className={"card-kpi-item"}>
                <KpiCard
                  app={app}
                  KPITitle={nameKpi01}
                  valueId={OBJECT_IDS.KPI_REALIZADO}
                  goalValueId={OBJECT_IDS.KPI_META}
                  percentageId={OBJECT_IDS.KPI_ATING}
                  hasProgressBar={true}
                  fullView
                />
              </Card>

              <Card
                app={app}
                className={"card-item"}
                header={{
                  hardTitle: nameKpi02,
                }}
              >
                <div className="content-card">
                  <p className="subtitle">{month01}</p>
                  <p className="container-values">
                    <span className="item-value">{valueRealizado}</span>
                    <span className="item-text">Realizado</span>
                  </p>
                </div>
              </Card>

              <Card
                app={app}
                className={"card-item"}
                header={{
                  hardTitle: nameKpi03,
                }}
              >
                <div className="content-card">
                  <p className="subtitle">{month02}</p>
                  <p className="container-values">
                    <span className="item-value">{valueRealizado02}</span>
                    <span className="item-text">Realizado</span>
                  </p>
                </div>
              </Card>

              <Card
                app={app}
                className={"card-item"}
                header={{
                  hardTitle: nameKpi04,
                }}
              >
                <div className="content-card">
                  <p className="subtitle">{month03}</p>
                  <p className="container-values">
                    <span className="item-value">{valueRealizado03}</span>
                    <span className="item-text">Realizado</span>
                  </p>
                </div>
              </Card>
            </Grid>
          </Grid>

          <Grid className="container-desempenho" sx={{ marginBottom: "16px" }}>
            <Card
              app={app}
              header={{
                hardTitle: "Acompanhamento por Quarter",
              }}
              className="card-desempenho"
            >
              <div className="container-legends">
                <p className="container-item item-meta">
                  <span className="item-color color-meta" />
                  <span className="item-text">Meta</span>
                </p>

                <p className="container-item item-realizado">
                  <span className="item-color color-realizado" />
                  <span className="item-text">Realizado</span>
                </p>
              </div>
              <NativeObject
                app={app}
                key="GsxtkTJ"
                reference={{ id: "GsxtkTJ" }}
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
            </Card>
          </Grid>

          <Grid className="container-desempenho">
            <Card
              app={app}
              header={{
                hardTitle: "Desempenho",
              }}
              className="card-desempenho"
              absoluteExpandButton={true}
              exportContainer
              exportTable
              exportTableId="tMPvmPh"
              expandable
            >
              <NativeObject
                app={app}
                key="tMPvmPh"
                reference={{ id: "tMPvmPh" }}
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
            </Card>
          </Grid>

          <Grid className="container-performance">
            <Card
              app={app}
              header={{
                hardTitle: "Acompanhamento Mensal",
              }}
              exportContainer
              exportTable
              exportTableId="EXvCWj"
              expandable
              className="card-performance"
            >
              <NativeObject
                app={app}
                key="EXvCWj"
                reference={{ id: "EXvCWj" }}
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

SellOutTotalDesktop.defaultProps = {
  app: null,
  config: {},
};

SellOutTotalDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutTotalDesktop;
